import React, { FunctionComponent } from 'react';

export const DimensionSeparator: FunctionComponent = () => <> x </>;
